export default __webpack_public_path__ + "static/media/comming_soon.0d8ce81b.svg";